import { Link } from "@custom/schema";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/outline";
import clsx from "clsx";
import React from "react";
import { isTruthy } from "../../utils/isTruthy";
export default function Breadcrumbs(props) {
    var _props_items, _items, _items_, _items_1, _items_2, _items1;
    var items = (_props_items = props.items) === null || _props_items === void 0 ? void 0 : _props_items.filter(isTruthy);
    return /*#__PURE__*/ React.createElement("nav", {
        className: "flex overflow-x-auto not-prose container-page paragraph-container",
        "aria-label": "Breadcrumb"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "md:hidden "
    }, !!((_items = items) === null || _items === void 0 ? void 0 : _items[items.length - 2]) && /*#__PURE__*/ React.createElement(Link, {
        title: (_items_ = items[items.length - 2]) === null || _items_ === void 0 ? void 0 : _items_.title,
        href: ((_items_1 = items[items.length - 2]) === null || _items_1 === void 0 ? void 0 : _items_1.url) || "/",
        className: "text-xs leading-xs flex items-center gap-2 focus-dark uppercase text-gray-700 hover:text-black font-semibold"
    }, /*#__PURE__*/ React.createElement(ChevronLeftIcon, {
        className: "h-4 w-4",
        "aria-hidden": "true"
    }), (_items_2 = items[items.length - 2]) === null || _items_2 === void 0 ? void 0 : _items_2.title)), /*#__PURE__*/ React.createElement("ol", {
        className: "hidden md:flex md:flex-row md:flex-1 items-center gap-2"
    }, (_items1 = items) === null || _items1 === void 0 ? void 0 : _items1.map(function(param, index) {
        var title = param.title, url = param.url;
        return /*#__PURE__*/ React.createElement("li", {
            className: "flex items-center gap-2",
            key: title
        }, /*#__PURE__*/ React.createElement(Link, {
            href: url,
            title: title,
            className: clsx("flex items-center gap-2 text-xs leading-xs transition-all focus-dark uppercase font-semibold", index !== items.length - 1 ? "text-gray-700 hover:text-black" : "text-black hover:text-gray-700")
        }, title, index !== items.length - 1 && /*#__PURE__*/ React.createElement(ChevronRightIcon, {
            className: "h-4 w-4",
            "aria-hidden": "true"
        })));
    })));
}
